module.exports = __webpack_public_path__ + "static/media/wizualizacja-49.c3b8a94e.png";